import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { regionService } from "../shared/api/regionService";

interface Props {
	regionId: Id;
	handleEdit: () => void;
	handleDelete: () => Promise<any>;
}

export const RegionListContextMenu: FC<Props> = ({ regionId, handleEdit, handleDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(() => regionService.usages(regionId).then((r) => r.data.data), [regionId]);

	const canUpdate = useHasPermission<PermissionName>(["region.update"]);
	const canDelete = useHasPermission<PermissionName>(["region.delete"]);

	return (
		<>
			<ContextMenu displayShortcutsAs="icon">
				{canUpdate && (
					<ContextMenuItem label={t("Edit")} action={handleEdit} title={t("Edit")} icon="edit" shortcut="primary" />
				)}
				{canDelete && (
					<ContextMenuDeleteWithModelUsageItem
						label={t("Delete")}
						title={t("Delete")}
						showUsageAction={showUsageAction}
						modelName={t("Region")}
						confirmationBody={t("Are you sure you want to delete this region?")}
						deleteAction={handleDelete}
						shortcut="danger"
					/>
				)}
			</ContextMenu>
		</>
	);
};
